export class OnlineOrderUrlModel implements OLO.DTO.OnlineOrderUrlModel {
    public UrlType: APICommon.ORDER_URL_TYPE = APICommon.ORDER_URL_TYPE.ORDER_CONFIRMATION;

    constructor(public AccessToken: string, public Url: string) {}
}
